import { useToastContext } from '../contexts/ToastContext';

/**
 * App-wide toast helpers. Requires ToastProvider (wired in App).
 */
export const useToast = () => {
  const { toasts, showToast, removeToast, success, error, info, warning } = useToastContext();
  return {
    toasts,
    showToast,
    removeToast,
    success,
    error,
    info,
    warning,
  };
};
